import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes/AppRoutes";



function App() {
  return (
    <>
      <Router>
        <AppRoutes />  
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
